import React, { useContext } from 'react'
import AnimatedCursor from "react-animated-cursor"
import { ThemeContext } from '../context/ThemeContext'
const CustomCursor = () => {
    const { Theme } = useContext(ThemeContext)
    return (
        <AnimatedCursor
            innerSize={12}
            outerSize={40}
            color={Theme === "dark" ?'209, 204, 48':'238, 30, 64'}
            outerAlpha={0.2}
            innerScale={0.7}
            outerStyle={{
                zIndex: 10000
            }}
            innerStyle={{
                zIndex: 10000
            }}
            outerScale={2}
            clickables={[
                'a',
                'span',
                'li',
                'img',
                'input[type="text"]',
                'input[type="email"]',
                'input[type="number"]',
                'input[type="submit"]',
                'input[type="image"]',
                'label[for]',
                'select',
                'textarea',
                'button',
            ]}
        />
    )
}

export default CustomCursor